var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFb1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.0886 24.9346C48.0886 11.6798 37.3433 0.934555 24.0886 0.934555C10.8339 0.934555 0.088623 11.6798 0.088623 24.9346C0.088623 36.1896 7.83774 45.6341 18.2912 48.228V32.269H13.3424V24.9346H18.2912V21.7742C18.2912 13.6056 21.9881 9.81936 30.008 9.81936C31.5286 9.81936 34.1523 10.1179 35.2256 10.4155V17.0635C34.6592 17.004 33.6752 16.9742 32.4531 16.9742C28.5181 16.9742 26.9974 18.4651 26.9974 22.3406V24.9346H34.8368L33.4899 32.269H26.9974V48.7589C38.8813 47.3237 48.0896 37.2053 48.0896 24.9346H48.0886Z",
    fill: "#0866FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb1);
export default __webpack_public_path__ + "static/media/fb (1).1f971ab9aeaf9eb30d2028e36e3e40d0.svg";
export { ForwardRef as ReactComponent };